namespace uh.scene {
    export class Boot extends Phaser.Scene {
        init() {
            // game.input.mouse.enabled = !game.device.input.touch;

            new FitScaleManager(this.game).setup();
        }

        create() {
            game.scene.remove('Boot');
            game.scene.add('Preloader', uh.scene.Preloader, true);
        }
    }
}